import { HTMLAttributes } from 'react'
import Link from 'next/link'

import Button from '@/components/base/Button'
import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Section from '@/components/base/Section'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { cn } from '@/lib/utils'
import { WPLink } from '@/types'

export type TextBlockProps = HTMLAttributes<HTMLElement> &
  Partial<{
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    title: string
    paragraph: string
    button: WPLink
  }>

const TextBlock = ({
  title,
  title_variant,
  title_component,
  paragraph,
  button,
  className,
  ...props
}: TextBlockProps) => {
  return (
    <Section className={cn([className])} {...props}>
      <Container>
        <Grid>
          <div
            className={cn([
              'col-span-4 md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3',
              'grid gap-y-gutter text-center'
            ])}
          >
            {title ? (
              <Typography variant={title_variant} component={title_component}>
                {title}
              </Typography>
            ) : null}

            {paragraph ? (
              <Typography
                variant="body"
                paragraph
                className="mx-auto max-w-[65rem]"
              >
                {paragraph}
              </Typography>
            ) : null}

            {button ? (
              <div className="flex justify-center">
                <Button variant="default" asChild>
                  <Link href={button.url} target={button.target}>
                    <span data-label={button.title}>
                      <Typography variant="label">{button.title}</Typography>
                    </span>
                  </Link>
                </Button>
              </div>
            ) : null}
          </div>
        </Grid>
      </Container>
    </Section>
  )
}

export default TextBlock
